import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/authContext';
import styles from './RegisterPage.module.css';
import apiRequest from '../../lib/apiRequest';
import logger from '../../lib/logger';

const RegisterPage = () => {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    try {
      const response = await apiRequest.post(
        '/auth/register',
        { email, password },
      );

      if (!response.data.success) {
        setErrorMessage(response.data.message || 'Registration failed.');
        return;
      }

      const data = response.data;
      setSuccessMessage(data.message || 'Registration successful!');

      // Optionally clear the form
      setEmail('');
      setPassword('');

      // Only log in the user if they are already verified (or handle pending verification in your UI)
      if (data.user.verified) {
        login(data.user);
        setTimeout(() => {
          navigate('/');
        }, 500);
      }
    } catch (error) {
      logger.error('Error during registration:', error);
      setErrorMessage(error.response?.data?.message || 'Registration failed.');
    }
  };

  return (
    <div className={styles.registerContainer}>
      <h2 className={styles.registerHeading}>Create an Account</h2>
      <form onSubmit={handleSubmit} className={styles.registerForm}>
        <label htmlFor="email" className={styles.registerLabel}>
          Email
        </label>
        <input
          id="email"
          type="email"
          className={styles.registerInput}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label htmlFor="password" className={styles.registerLabel}>
          Password
        </label>
        <input
          id="password"
          type="password"
          className={styles.registerInput}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {errorMessage && (
          <div className={styles.errorMessage}>{errorMessage}</div>
        )}
        {successMessage && (
          <div className={styles.successMessage}>{successMessage}</div>
        )}

        <button type="submit" className={styles.registerButton}>
          Register
        </button>
      </form>
    </div>
  );
};

export default RegisterPage;
